import type { FieldError } from 'react-hook-form';

import { VOUCHER_REWARD_TYPE_OPTIONS } from '../constants';
import { OPTION_VALUE_TO_REWARD_TYPE } from '../constants/voucher-product-form.constants';
import type { RewardType } from '../types/voucher-product-form.types';

export const mapOptionToRewardType = (
  value: (typeof VOUCHER_REWARD_TYPE_OPTIONS)[number]['value']
): RewardType => OPTION_VALUE_TO_REWARD_TYPE[value] ?? 'FREE_GOODS';

export const getRewardTypeIndex = (rewardType: RewardType): number =>
  Math.max(
    0,
    VOUCHER_REWARD_TYPE_OPTIONS.findIndex(
      (item) => mapOptionToRewardType(item.value) === rewardType
    )
  );

export const getFieldErrorMessage = (
  error?: FieldError | { value?: FieldError }
) => {
  if (!error) return undefined;
  if ('message' in error && error.message) return error.message;
  if ('value' in error && error.value?.message) return error.value.message;
  return undefined;
};
